var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.856 5.142h4.286a2.143 2.143 0 1 0-4.286 0m-1.286 0a3.429 3.429 0 0 1 6.858 0h5.357a.643.643 0 0 1 0 1.286h-1.123l-1.043 12.517a3.643 3.643 0 0 1-3.63 3.34h-5.98a3.643 3.643 0 0 1-3.63-3.34L4.336 6.428H3.213a.643.643 0 1 1 0-1.286zM6.66 18.838A2.357 2.357 0 0 0 9.01 21h5.979a2.357 2.357 0 0 0 2.348-2.162l1.036-12.41H5.626zm3.41-9.41a.643.643 0 0 1 .643.643v7.286a.643.643 0 0 1-1.286 0V10.07a.643.643 0 0 1 .643-.643m4.5.643a.643.643 0 1 0-1.285 0v7.286a.643.643 0 1 0 1.285 0z",
    fill: "#E56363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2758c9559635bd6557664fec830d85f0.svg";
export { ForwardRef as ReactComponent };